






































/* tslint:disable:no-var-requires */
import { Component, Vue } from 'vue-property-decorator'
import {store, WorkItem} from '@/app/store'
@Component({
  components: {
  },
})
export default class Works extends Vue {
  items = store.works
  clickCard(item:WorkItem){
    console.log('clickCard')
    this.$router.push(`/works/${item.name}`)
  }
}
